import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MyPreset } from './mypreset';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { errorLogInterceptor } from './core/interceptors/error-log.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
      withInterceptors([loadingInterceptor, authInterceptor, errorLogInterceptor])
    ),
    provideRouter(routes),
    providePrimeNG({
      translation: {
        // WCAG 1.1.1: Italian labels for PrimeNG interactive controls read by screen readers
        clear: 'Rimuovi selezione',
        accept: 'Sì',
        reject: 'No',
        choose: 'Scegli',
        upload: 'Carica',
        cancel: 'Annulla',
        today: 'Oggi',
        apply: 'Applica',
        selectionMessage: '{0} elementi selezionati',
        emptySelectionMessage: 'Nessun elemento selezionato',
        emptySearchMessage: 'Nessun risultato trovato',
        searchMessage: 'Risultati di ricerca disponibili',
      },
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.p-dark', // Optional: for dark mode support
          ripple: true // Il sito ufficiale usa l'effetto ripple
        }
      }
    }),
    ConfirmationService,
    MessageService
  ]
};
